import React from 'react';

import { CenteredLoadingPage } from './CenteredLoadingPage';

export const Authenticating = () => (
  <CenteredLoadingPage text="Authenticating…" />
);
